import * as React from 'react';
import { SVGProps } from 'react';

const IconMailSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 2a1 1 0 0 0-1 1v.567l5 2.857 5-2.857V3a1 1 0 0 0-1-1H2z" />
    <path d="M11 4.719 6 7.576 1 4.719V9a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.719z" />
  </svg>
);
export default IconMailSizeXs;
